import { combineReducers } from '@reduxjs/toolkit';


import type { State as ListState } from './list/reducers';
import type { State as PagingState } from './paging/reducers';
import type { State as FiltersState } from './filters/reducers';

import { INITIAL_STATE as LIST_INITIAL_STATE } from './list/reducers';
import { INITIAL_STATE as PAGING_INITIAL_STATE } from './paging/reducers';
import { INITIAL_STATE as FILTERS_INITIAL_STATE } from './filters/reducers';

import listSlice from './list/reducers';
import pagingSlice from './paging/reducers';
import filtersSlice from './filters/reducers';

export interface State {
	list: ListState,
	paging: PagingState,
	filters: FiltersState,
};

export const INITIAL_STATE: State = {
	list: LIST_INITIAL_STATE,
	paging: PAGING_INITIAL_STATE,
	filters: FILTERS_INITIAL_STATE
};

export const reducers = combineReducers({
	list: listSlice,
	paging: pagingSlice,
	filters: filtersSlice
});
